"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6556],{

/***/ 23483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseIconBlack = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.46584 8.00012L15.6959 1.76972C16.1014 1.36446 16.1014 0.709208 15.6959 0.303946C15.2907 -0.101315 14.6354 -0.101315 14.2302 0.303946L7.99991 6.53434L1.76983 0.303946C1.36438 -0.101315 0.709335 -0.101315 0.304082 0.303946C-0.101361 0.709208 -0.101361 1.36446 0.304082 1.76972L6.53416 8.00012L0.304082 14.2305C-0.101361 14.6358 -0.101361 15.291 0.304082 15.6963C0.506044 15.8984 0.771594 16 1.03695 16C1.30231 16 1.56767 15.8984 1.76983 15.6963L7.99991 9.46589L14.2302 15.6963C14.4323 15.8984 14.6977 16 14.963 16C15.2284 16 15.4938 15.8984 15.6959 15.6963C16.1014 15.291 16.1014 14.6358 15.6959 14.2305L9.46584 8.00012Z",
            fill: "black"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIconBlack);


/***/ }),

/***/ 90042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_PromosDrawerAndButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconBlack.js
var CloseIconBlack = __webpack_require__(23483);
;// CONCATENATED MODULE: ./src/components/FloatingButtonAndDrawer/index.tsx






var FloatingButtonAndDrawer = function(param) {
    var buttonConfig = param.buttonConfig, showDrawer = param.showDrawer, onClose = param.onClose, drawerHeading = param.drawerHeading, additionalHeaderComponent = param.additionalHeaderComponent, children = param.children, showCloseIcon = param.showCloseIcon;
    var renderFloatingButton = function renderFloatingButton() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-fixed  tw-bottom-1/2 tw-right-0 tw-origin-bottom-right -tw-rotate-90 ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "tw-flex tw-cursor-pointer tw-items-center tw-gap-[4px] tw-border-none tw-px-[28px] tw-py-[8px] tw-text-[15px]/[20px] tw-font-bold tw-text-white md:tw-py-[12px]  ",
                style: {
                    backgroundColor: themeColor
                },
                onClick: onButtonClick,
                children: [
                    buttonConfig.icon || null,
                    " ",
                    buttonConfig.text
                ]
            })
        });
    };
    var renderDrawerHeader = function renderDrawerHeader() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-sticky tw-top-0 tw-z-50 tw-border-b tw-border-solid tw-border-[#E3E3E3] tw-bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[12px] tw-px-[20px] tw-py-[32px] tw-text-[18px]/[20px] tw-font-semibold md:tw-px-[24px]",
                    children: [
                        (showCloseIcon !== null && showCloseIcon !== void 0 ? showCloseIcon : true) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-flex tw-cursor-pointer",
                            onClick: onCloseFinal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconBlack/* default */.Z, {
                                size: checkClientDeviceType/* IS_DESKTOP */.yn ? 16 : 12
                            })
                        }),
                        drawerHeading
                    ]
                }),
                additionalHeaderComponent
            ]
        });
    };
    var renderDrawerContent = function renderDrawerContent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-flex-col",
            children: children
        });
    };
    var ref = (0,react.useState)(false), openDrawer = ref[0], setOpenDrawer = ref[1];
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var onCloseDrawer = function() {
        return setOpenDrawer(false);
    };
    var onOpenDrawer = function() {
        return setOpenDrawer(true);
    };
    var showFinal = showDrawer !== null && showDrawer !== void 0 ? showDrawer : openDrawer;
    var onCloseFinal = onClose !== null && onClose !== void 0 ? onClose : onCloseDrawer;
    var _onClick;
    var onButtonClick = (_onClick = buttonConfig.onClick) !== null && _onClick !== void 0 ? _onClick : onOpenDrawer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderFloatingButton(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                open: showFinal,
                onClose: onCloseFinal,
                classes: {
                    paper: checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-w-[40%] tw-min-w-[596px]" : "tw-h-full"
                },
                anchor: checkClientDeviceType/* IS_DESKTOP */.yn ? "right" : "bottom",
                transitionDuration: checkClientDeviceType/* IS_DESKTOP */.yn ? 300 : 400,
                children: [
                    renderDrawerHeader(),
                    renderDrawerContent()
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FloatingButtonAndDrawer = (FloatingButtonAndDrawer);

// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(93757);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/TabsContainer/index.tsx
var TabsContainer = __webpack_require__(1325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(68615);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/PromosContainer.tsx
var PromosContainer = __webpack_require__(69708);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/StoreOffersSection.tsx


var StoreOffersSection = function(param) {
    var storePromos = param.storePromos, onPromoClick = param.onPromoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosContainer/* PromosContainer */.$, {
        promos: storePromos,
        onPromoClick: onPromoClick,
        customClasses: "tw-flex tw-flex-col md:tw-px-[24px] md:tw-py-[21px]",
        primaryTextClasses: "tw-text-[13px]/[18px] tw-font-medium md:tw-text-[16px]/[20px] md:tw-font-semibold",
        secondaryTextClasses: "tw-text-[12px]/[20px] tw-font-normal md:tw-text-[15px]/[20px]"
    });
};
/* harmony default export */ var PromosSections_StoreOffersSection = (StoreOffersSection);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/BankOffers/index.tsx
var BankOffers = __webpack_require__(11110);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/BankOffersSection.tsx


var BankOffersSection = function(param) {
    var paymentOffersList = param.paymentOffersList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BankOffers/* default */.Z, {
        showAllPromos: true,
        paymentOffersList: paymentOffersList,
        isCartPage: false
    });
};
/* harmony default export */ var PromosSections_BankOffersSection = (BankOffersSection);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(82516);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/index.tsx











var PromosDrawerAndButton = function() {
    var getPromos = function getPromos() {
        var data = {
            storeId: storeId,
            userId: userId
        };
        dispatch((0,promo/* getAllPromos */.mv)(data, function(allPromos) {
            return dispatch((0,promo/* saveCouponsList */.Kp)({
                coupons: allPromos
            }));
        }));
        dispatch((0,promo/* getPaymentOffersList */.Xu)(storeId));
    };
    var openPromoModal = function openPromoModal(promoId) {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoId
        }));
        checkClientDeviceType/* IS_DESKTOP */.yn && setShowPromos(false);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0,
            paymentOffersList: state.promoReducer.paymentOffersList || [],
            promos: state === null || state === void 0 ? void 0 : (ref1 = state.promoReducer) === null || ref1 === void 0 ? void 0 : ref1.couponsList
        };
    }), storeId = ref.storeId, userId = ref.userId, paymentOffersList = ref.paymentOffersList, promos = ref.promos;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    var ref1 = (0,react.useState)(0), activeTabIndex = ref1[0], setActiveTabIndex = ref1[1];
    var ref2 = (0,react.useState)(false), showPromos = ref2[0], setShowPromos = ref2[1];
    var tabsData = [
        {
            text: "Store Offers"
        },
        {
            text: "Bank Offers"
        }, 
    ];
    (0,react.useEffect)(function() {
        if (storeId && !isCouponsFeatureLocked && !promos.length) {
            getPromos();
        }
    }, [
        storeId,
        isCouponsFeatureLocked
    ]);
    var showStoreOffers = activeTabIndex === 0;
    return !isCouponsFeatureLocked && !!promos.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FloatingButtonAndDrawer, {
            buttonConfig: {
                text: "Offers",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {}),
                onClick: function() {
                    return setShowPromos(true);
                }
            },
            showDrawer: showPromos,
            onClose: function() {
                return setShowPromos(false);
            },
            drawerHeading: "Offers",
            additionalHeaderComponent: !!(paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer/* default */.Z, {
                activeTabIndex: activeTabIndex,
                setActiveTabIndex: setActiveTabIndex,
                tabsData: tabsData,
                tabClasses: "!tw-text-[14px]/[20px] md:!tw-text-[18px]/[20px] !tw-px-[20px] md:!tw-px-[32px] tw-pb-[18px]"
            }),
            children: showStoreOffers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_StoreOffersSection, {
                storePromos: promos,
                onPromoClick: openPromoModal
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_BankOffersSection, {
                paymentOffersList: paymentOffersList
            })
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromosDrawerAndButton = (PromosDrawerAndButton);


/***/ }),

/***/ 15241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FullPageLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79220);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74151);



// import interLoader from '../../../public/assets/images/inter-loader.gif';


function FullPageLoader() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var globalLoader = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            globalLoader: state.commonReducer.globalLoader
        };
    }).globalLoader;
    return globalLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "global-loader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__/* .GlobalCfeLoader */ .I, {
            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.appLoader) === null || ref === void 0 ? void 0 : ref.loaderId) || "ellipsis",
            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.color
        })
    });
}


/***/ }),

/***/ 62769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ persistScrollPosition; },
/* harmony export */   "l": function() { return /* binding */ useScrollAnchor; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87243);



function persistScrollPosition() {
    var scrollConfig = (0,_utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_2__/* .scrollOnPageLoad */ .l)();
    if (!scrollConfig.toScroll) {
        return;
    }
    var x_scroll = scrollConfig.x_scroll, y_scroll = scrollConfig.y_scroll;
    setTimeout(function() {
        window.scrollTo(x_scroll, y_scroll);
        sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
    }, 300);
}
function useScrollAnchor() {
    var isPageRefreshed = // Check was it refreshed/reloaded using the browser's reload button
    function isPageRefreshed() {
        var ref, ref1;
        var performance = window.performance;
        if (!performance) {
            return false;
        }
        return performance.navigation && performance.navigation.type === 1 || performance.getEntriesByType("navigation").map(function(nav) {
            return nav.type;
        }).includes("reload") || (performance === null || performance === void 0 ? void 0 : (ref = performance.navigation) === null || ref === void 0 ? void 0 : ref.type) == (performance === null || performance === void 0 ? void 0 : (ref1 = performance.navigation) === null || ref1 === void 0 ? void 0 : ref1.TYPE_RELOAD);
    };
    var resetScrollPosition = function resetScrollPosition() {
        setTimeout(function() {
            sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
            window.scrollTo(0, 0);
        }, 300);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var wasPageRefreshed = isPageRefreshed();
        if (!wasPageRefreshed) persistScrollPosition();
        else resetScrollPosition();
    }, []);
    return null;
}


/***/ }),

/***/ 32997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(53978);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(98616);
// EXTERNAL MODULE: ./src/utils/localStorageFunctions.js
var localStorageFunctions = __webpack_require__(74943);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/containers/Home/hooks/useScrollAnchor.ts
var useScrollAnchor = __webpack_require__(62769);
// EXTERNAL MODULE: ./src/utils/getAuthToken.js
var getAuthToken = __webpack_require__(61305);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var user = __webpack_require__(56173);
;// CONCATENATED MODULE: ./src/containers/Home/hooks/useCheckUserLoginStatus.ts




function useCheckUserLoginStatus() {
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var authToken = (0,getAuthToken/* getAuthToken */.b)();
        if (authToken) {
            var authData = {
                auth_token: authToken,
                service: ""
            };
            dispatch((0,auth/* authenticateUser */.So)(authData));
        } else {
            dispatch((0,user/* setLogout */.wt)());
        }
    }, []);
    return null;
}

// EXTERNAL MODULE: ./src/redux/actions/leadgen.js
var leadgen = __webpack_require__(171);
// EXTERNAL MODULE: ./src/utils/checkIfThemeEditorOrPreview.js
var checkIfThemeEditorOrPreview = __webpack_require__(35069);
;// CONCATENATED MODULE: ./src/containers/Home/hooks/useActiveLeadGenStatus.ts




function useActiveLeadGenStatus(storeId, checkLeadgenPopup) {
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (storeId) {
            if (!(0,checkIfThemeEditorOrPreview/* default */.Z)()) {
                dispatch((0,leadgen/* getStoreActiveLeadGenTemplate */.d9)({
                    store_id: storeId
                }, function(data) {
                    return data.status && setTimeout(checkLeadgenPopup, 5000);
                }));
            }
        }
    }, [
        storeId
    ]);
    return null;
}

// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/containers/Home/hooks/useInstallApp.ts




function useInstallApp(store) {
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var ref;
        var storeDomain = store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain;
        var athsBeforeInstall = function(e) {
            e.preventDefault();
            dispatch((0,common/* saveATHSEvent */.pG)(e));
        };
        window.addEventListener("beforeinstallprompt", athsBeforeInstall);
        window.addEventListener("appinstalled", function() {
            // (Old code is pasted here) 5 is passed as number as this would need to be changed on all instances
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("".concat(storeDomain, "-aths-noOfCount"), 5);
            (0,Toast/* toastNotifySuccess */.jh)("Your App will be visible in sometime !");
        });
        return function() {
            window.removeEventListener("beforeinstallprompt", athsBeforeInstall);
        };
    }, []);
    return null;
}

// EXTERNAL MODULE: ./src/redux/actions/cart.js
var actions_cart = __webpack_require__(66162);
;// CONCATENATED MODULE: ./src/containers/Home/hooks/useCartAsyncCall.ts





function useCartAsyncCall(storeData) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var cart = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer
        };
    }).cart;
    (0,react.useEffect)(function() {
        setCartAsyncCall();
    }, [
        cart.pay_amount
    ]);
    var setCartAsyncCall = function() {
        return new Promise(function(resolve) {
            dispatch((0,actions_cart/* setCart */.RV)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart), {
                order_type: cart.order_type,
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                user_phone: cart.phone,
                cart_id: cart.cart_id
            }), function(status) {
                resolve(null);
            }));
        });
    };
    return null;
}

;// CONCATENATED MODULE: ./src/containers/Home/hooks/useSaveQueryParams.ts

function useSaveQueryParams() {
    (0,react.useEffect)(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var utmSource = urlParams.get("utm_source");
        if ((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("utm_source")) !== utmSource) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("utm_source", utmSource);
        }
    }, []);
    return null;
}

// EXTERNAL MODULE: ./src/utils/isThemeBrandWebsite.js
var isThemeBrandWebsite = __webpack_require__(20955);
// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(80344);
;// CONCATENATED MODULE: ./src/utils/isFormPresent.js

var isFormPresent = function() {
    var ref, ref1, ref2, ref3, ref4;
    var storeTheme = (ref = store/* default.getState */.Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.storeReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store) === null || ref2 === void 0 ? void 0 : ref2.theme;
    var themeFormConfig = storeTheme === null || storeTheme === void 0 ? void 0 : (ref3 = storeTheme.components) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Body) === null || ref4 === void 0 ? void 0 : ref4.filter(function(comp) {
        return comp.sub_type === "Form";
    });
    if (themeFormConfig && (themeFormConfig === null || themeFormConfig === void 0 ? void 0 : themeFormConfig.length) > 0) return true;
    return false;
};

// EXTERNAL MODULE: ./src/constants/widgets.ts
var widgets = __webpack_require__(42381);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
;// CONCATENATED MODULE: ./src/utils/checkIfWhatsAppVisible.js



var checkIfWhatsAppVisible = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var storeTheme = (ref = store/* default.getState */.Z.getState().storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : ref1.theme;
    var isCustomTheme = !!(storeTheme === null || storeTheme === void 0 ? void 0 : storeTheme.custom_theme_flag);
    var isBrandWebsiteTheme = !!(storeTheme === null || storeTheme === void 0 ? void 0 : storeTheme.brand_website_flag);
    var headerComponent = storeTheme === null || storeTheme === void 0 ? void 0 : (ref2 = storeTheme.components) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Header) === null || ref3 === void 0 ? void 0 : ref3[0];
    var isHeader14 = (headerComponent === null || headerComponent === void 0 ? void 0 : headerComponent.name) === "Header14";
    var isNewHeader = (headerComponent === null || headerComponent === void 0 ? void 0 : headerComponent.name) === widgets/* ADMIN_WIDGETS.HEADER.name */.Pe.HEADER.name;
    var whatsAppVisibilityFromHeader = !!(headerComponent === null || headerComponent === void 0 ? void 0 : (ref4 = headerComponent.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hidden_components) === null || ref5 === void 0 ? void 0 : ref5.whatsapp_view);
    if (isNewHeader) {
        var ref6, ref7, ref8, ref9, ref10, ref11;
        whatsAppVisibilityFromHeader = (ref10 = headerComponent === null || headerComponent === void 0 ? void 0 : (ref6 = headerComponent.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.navIcons_section) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.componentData) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.iconsList) === null || ref9 === void 0 ? void 0 : ref9.find(function(item) {
            return item.name === "contact";
        })) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.visibility) === null || ref11 === void 0 ? void 0 : ref11.desktopHeader;
        if (whatsAppVisibilityFromHeader === undefined) whatsAppVisibilityFromHeader = true;
    }
    return isNewHeader ? false // whatsAppVisibilityFromHeader
     : isCustomTheme && isHeader14 ? whatsAppVisibilityFromHeader : !isBrandWebsiteTheme && deviceWidth/* deviceWidth */.o > 786;
};
/* harmony default export */ var utils_checkIfWhatsAppVisible = (checkIfWhatsAppVisible);

;// CONCATENATED MODULE: ./src/containers/Home/hooks/useGetConditionalRenderingData.ts




function useGetConditionalRenderingData(storeData) {
    var conditionals = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var floatingButtonComponent = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Body) === null || ref2 === void 0 ? void 0 : ref2.filter(function(comp) {
            return comp.sub_type === "FloatingButton";
        });
        var isFloatingComponentValid = Array.isArray(floatingButtonComponent) && (floatingButtonComponent === null || floatingButtonComponent === void 0 ? void 0 : floatingButtonComponent.length) > 0;
        var floatingComponentData = (floatingButtonComponent === null || floatingButtonComponent === void 0 ? void 0 : floatingButtonComponent[0]) || {};
        var floatingComponentConfig = floatingComponentData === null || floatingComponentData === void 0 ? void 0 : floatingComponentData.config;
        var isBrandWebsite = (0,isThemeBrandWebsite/* isThemeBrandWebsite */.h)();
        var formPresent = isFormPresent();
        var showModernForm = isBrandWebsite && formPresent;
        var showEnquiryForm = showModernForm && isFloatingComponentValid && (floatingComponentConfig === null || floatingComponentConfig === void 0 ? void 0 : (ref3 = floatingComponentConfig.enquiryForm) === null || ref3 === void 0 ? void 0 : ref3.isEnabled);
        var showFloatingButton = isBrandWebsite && isFloatingComponentValid && ((floatingComponentConfig === null || floatingComponentConfig === void 0 ? void 0 : (ref4 = floatingComponentConfig.scrollToTop) === null || ref4 === void 0 ? void 0 : ref4.isEnabled) || (floatingComponentConfig === null || floatingComponentConfig === void 0 ? void 0 : (ref5 = floatingComponentConfig.whatsappCTA) === null || ref5 === void 0 ? void 0 : ref5.isEnabled));
        var showFloatingWhatsappButton = utils_checkIfWhatsAppVisible();
        return {
            floatingComponentData: floatingComponentData,
            showModernForm: showModernForm,
            showEnquiryForm: showEnquiryForm,
            showFloatingButton: showFloatingButton,
            showFloatingWhatsappButton: showFloatingWhatsappButton
        };
    }, [
        storeData
    ]);
    return conditionals;
}

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/index.tsx + 3 modules
var PromosDrawerAndButton = __webpack_require__(90042);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/index.js + 7 modules
var ProductCustomizationPopUp = __webpack_require__(24648);
// EXTERNAL MODULE: ./src/components/FullPageLoader/FullPageLoader.js
var FullPageLoader = __webpack_require__(15241);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(40190);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
;// CONCATENATED MODULE: ./src/containers/Home/hooks/useSetBuilderContextWidgets.tsx



var useSetBuilderContextWidgets = function() {
    var widgets = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (state === null || state === void 0 ? void 0 : (ref = state.jsonWidgetsReducer) === null || ref === void 0 ? void 0 : ref.widgets) || [];
    });
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), setWidgets = ref.widgetContextActions.setWidgets, isBuilder = ref.widgetContextState.isBuilder;
    (0,react.useEffect)(function() {
        if (widgets && !isBuilder) {
            setWidgets(widgets);
        }
    }, [
        widgets
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/containers/Home/Home.js



















var ModernSideFloatingButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2086).then(__webpack_require__.bind(__webpack_require__, 72086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72086)
            ];
        }
    }
});
var ModernScrollFloatingButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6792).then(__webpack_require__.bind(__webpack_require__, 96792));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96792)
            ];
        }
    }
});
var VariantModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1868), __webpack_require__.e(6873)]).then(__webpack_require__.bind(__webpack_require__, 40261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40261)
            ];
        }
    }
});
var VariantChooseRepeatModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2948).then(__webpack_require__.bind(__webpack_require__, 32948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32948)
            ];
        }
    }
});
var VariantSelectedListModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4557).then(__webpack_require__.bind(__webpack_require__, 84557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84557)
            ];
        }
    }
});
var LeadGenerationModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9832).then(__webpack_require__.bind(__webpack_require__, 59832));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59832)
            ];
        }
    }
});
var FloatingWhatsapp = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8220).then(__webpack_require__.bind(__webpack_require__, 18220)).then(function(mod) {
        return mod.FloatingWhatsapp;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18220)
            ];
        }
    }
});
var QuickViewModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7856), __webpack_require__.e(9228), __webpack_require__.e(4429), __webpack_require__.e(8557), __webpack_require__.e(4556), __webpack_require__.e(5684), __webpack_require__.e(5823)]).then(__webpack_require__.bind(__webpack_require__, 60822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60822)
            ];
        }
    }
});
var ModernForm1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4518).then(__webpack_require__.bind(__webpack_require__, 74518));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74518)
            ];
        }
    }
});




var Home = function(props) {
    var checkLeadgenPopup = function checkLeadgenPopup() {
        if (!(0,localStorageFunctions/* getLeadPopup */.hK)()) setShowLeadgenPopup(true);
    };
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,react.useState)(false), showLeadgenPopup = ref2[0], setShowLeadgenPopup = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            formToggleState: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.toggleFormState,
            pdpData: state.catalogReducer.pdpData,
            personalizedProduct: (ref1 = state.catalogReducer) === null || ref1 === void 0 ? void 0 : ref1.personalizedProduct
        };
    }), formToggleState = ref3.formToggleState, pdpData = ref3.pdpData, personalizedProduct = ref3.personalizedProduct;
    var ref4 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            widgets: state.jsonWidgetsReducer.widgets
        };
    }), storeData = ref4.storeData, widgets = ref4.widgets;
    useCheckUserLoginStatus();
    (0,useScrollAnchor/* useScrollAnchor */.l)();
    useSaveQueryParams();
    useInstallApp(storeData);
    useCartAsyncCall(storeData);
    useActiveLeadGenStatus(storeData === null || storeData === void 0 ? void 0 : storeData.store_id, checkLeadgenPopup);
    useSetBuilderContextWidgets();
    var ref5 = useGetConditionalRenderingData(storeData), showModernForm = ref5.showModernForm, showEnquiryForm = ref5.showEnquiryForm, showFloatingButton = ref5.showFloatingButton, showFloatingWhatsappButton = ref5.showFloatingWhatsappButton, floatingComponentData = ref5.floatingComponentData;
    var handleFormClose = function() {
        dispatch((0,common/* toggleFormWidget */.Aq)(false));
    };
    var onCloseLeadGenPop = function() {
        (0,localStorageFunctions/* setLeadPopup */.C5)(true);
        setShowLeadgenPopup(false);
    };
    var storeTheme = (0,specificThemeRender/* specificThemeRender */.t)(storeData, (ref = props.path) === null || ref === void 0 ? void 0 : ref.includes(routes.PATH.BUILDER_PREVIEW));
    var ref6 = (storeTheme === null || storeTheme === void 0 ? void 0 : storeTheme.components) || {}, tmp = ref6.Header, headerComponents = tmp === void 0 ? [] : tmp, tmp1 = ref6.Body, bodyComponents = tmp1 === void 0 ? [] : tmp1, tmp2 = ref6.Footer, footerComponents = tmp2 === void 0 ? [] : tmp2;
    var jsonWidgetData = bodyComponents.find(function(component) {
        return component.name === "JsonPageWidget";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "preHome-page",
        children: [
            (ref1 = headerComponents.slice(0, 1)) === null || ref1 === void 0 ? void 0 : ref1.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            jsonWidgetData ? (0,themeImports/* getThemeComponent */.s)(jsonWidgetData.sub_type, jsonWidgetData.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonWidgetData), {
                widgets: widgets || {},
                storeData: storeData
            })) : bodyComponents.map(function(layout) {
                var ref;
                layout.banner_fixed_ratio = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.banner_fixed_ratio;
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    showATCBtn: true
                }, layout), {
                    isLink: true
                }));
            }),
            footerComponents.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullPageLoader/* FullPageLoader */.B, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantChooseRepeatModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantSelectedListModal, {}),
            pdpData && (pdpData === null || pdpData === void 0 ? void 0 : pdpData.visible) && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickViewModal, {}),
            showLeadgenPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGenerationModal, {
                show: showLeadgenPopup,
                onClose: onCloseLeadGenPop
            }),
            showModernForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernForm1, {
                open: formToggleState,
                handleClose: handleFormClose
            }),
            showEnquiryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernSideFloatingButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, floatingComponentData), {
                inBuilder: false
            })),
            showFloatingButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernScrollFloatingButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, floatingComponentData), {
                inBuilder: false
            })),
            showFloatingWhatsappButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingWhatsapp, {}),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomizationPopUp/* ProductCustomizationPopUp */.X, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosDrawerAndButton/* default */.Z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/Home/index.js



/***/ }),

/***/ 55847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getMetaDescription; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getMetaDescription = function(storeInfo) {
    var seoDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    if (!storeInfo) return "";
    if (seoDetails) return seoDetails.description;
    var description = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_description;
    return description || "";
// const businessTypes = storeInfo.store_businesses;
// const isAddresVisible = storeInfo?.address?.visibility === 1 ? true : false;
// let match = 13;
// let description = '';
// // default
// if (businessTypes && businessTypes.length > 1) {
//   match = 11;
// } else if (
//   businessTypes &&
//   businessTypes.length === 1 &&
//   businessTypes[0].business_id === 8
// ) {
//   match = 11;
// } else if (businessTypes && businessTypes.length === 0) {
//   match = 11;
// }
// // Genral store
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 1)
//   match = 1;
// // Pharmacy & Wellness
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 2)
//   match = 2;
// // Mobile & Electronics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 3)
//   match = 3;
// // Clothing & Fashion
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 4)
//   match = 4;
// // Resturants, Food Joints & Bakery
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 5)
//   match = 5;
// // Stationary & Office Supplies
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 6)
//   match = 6;
// // Arts, Jewellery & Collections
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 7)
//   match = 7;
// // Fruits & Vegetables
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 13)
//   match = 8;
// // Furniture & Home Decor
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 14)
//   match = 9;
// // Beauty & Cosmetics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 15)
//   match = 10;
// // real estate
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16)
//   match = 12;
// switch (match) {
//   case 1:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Grocery & Dairy Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 2:
//     description = `Buy and Order online from  ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Pharmacy & Wellness Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 3:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Mobile & Electronics Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 4:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fashion Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 5:
//     description = `Order Food online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }|  Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     } . Order Now!`;
//     break;
//   case 6:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Stationary Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 7:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Arts, Jewellery & Collections Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 8:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fruits & Vegetables Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 9:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Furniture & Home Decor Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 10:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Beauty & Cosmetics Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 11:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 12:
//     description = `Buy / Sell / Rent your real estate dream property from ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     } | Real Estate Property ${storeInfo.store_info?.name}. Explore Now!`;
//     break;
//   default:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
// }
// return description;
};


/***/ }),

/***/ 87243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ })

}]);